import React from 'react'
import Vimeo from '@u-wave/react-vimeo';
import Spinner from '../../shared/Spinner';
import { FieldType } from '../../../types';
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import { klaviyoHandleClientData } from '../../../services/klaviyo';
import { ClientAction } from '../../../store/order';
import { gtmHandleDataLayer } from '../../../services/gtm';
import VimeoPlayer from './VimeoPlayer';
import ThumbnailImage from './Thumbnail';
import FileManagerPlayer from './FileManagerPlayer';

export interface VideoProps {
    field: FieldType;
    videoFieldProps: VideoFieldProps
}

export interface VideoFieldProps {
    type: string;
    data: Record<string, any>;
}

export default function VideoField({ videoFieldProps, field }: VideoProps) {

    if (videoFieldProps.type === "vimeo") return (
        <VimeoPlayer
            videoFieldProps={videoFieldProps}
            field={field}
            thumbnail={<ThumbnailImage videoFieldProps={videoFieldProps} field={field} />
            } />
    )

    if (videoFieldProps.type === "filemanager") return (
        <FileManagerPlayer
            videoFieldProps={videoFieldProps}
            field={field}
            thumbnail={<ThumbnailImage videoFieldProps={videoFieldProps} field={field} />
            } />
    );

    return (
        <></>
    )
}